
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Close = props => {
  const modClassName = props.className ? props.className + ' fe_c_icon--close' : ' fe_c_icon--close';

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <rect x="4" y="11.8" width="17" height="1.5" transform="translate(-5.2 12.5) rotate(-45)"></rect>
          <rect x="11.8" y="4" width="1.5" height="16.97" transform="translate(-5.2 12.5) rotate(-45)"></rect>
        </g>
      </g>
    </IconBase>);
};

Close.defaultProps = {
  title: 'Close',
};

export default Close;
